import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machine-groups-index-page', () => {
  void import('./internal/machine-groups-index-page').then(({ default: Component }) => Component());
});
